import {Box, Divider, Grid, Typography} from '@material-ui/core';
import {DeleteOutline, DescriptionOutlined} from '@material-ui/icons';
import Button from 'components/button';
import {Field, FileInput, Form} from 'components/forms';
import {autobind} from 'core-decorators';
import {isSessionSupervisor} from 'core/utils';
import deleteDesign from 'graphql/mutations/orders/delete-design.gql';
import submitDesign from 'graphql/mutations/orders/submit-design.gql';
import orderQuery from 'graphql/queries/order.gql';
import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import {compose, graphql} from 'react-apollo';
import {Link} from 'react-router-dom';
import styles from './styles.css';

@compose(
    graphql(submitDesign, {
        props: ({mutate, ownProps}) => ({
            submitDesign: variables => mutate({variables, refetchQueries: [{query: orderQuery, variables: {id: ownProps.order.id}}]}),
        }),
    }),
    graphql(deleteDesign, {
        props: ({mutate, ownProps}) => ({
            deleteDesign: variables => mutate({variables, refetchQueries: [{query: orderQuery, variables: {id: ownProps.order.id}}]}),
        }),
    }),
)

@autobind
export default class RouteSigns extends Component {
    static propTypes = {
        order: PropTypes.object.isRequired,
        userData: PropTypes.object.isRequired,
    };

    state = {
        errors: '',
        loading: false,
    };

    async submitDesign(values) {
        if (window.confirm('¿Estás seguro de que querés continuar?')) {
            this.setState({loading: true});
            const response = await this.props.submitDesign({
                ...values,
                order: this.props.order.id,
                signFiles: this.props.order.signFiles[0].id,
            });
            if (response.data.action.success === true) {
                this.setState({
                    loading: false,
                });
            } else {
                this.setState({
                    loading: false,
                    errors: 'ha ocurrido un error al subir el diseño.',
                });
            }
        }
    }

    async handleDelete() {
        if (window.confirm('¿Realmente querés eliminar diseño?')) {
            const response = await this.props.deleteDesign({
                signFiles: this.props.order.signFiles[0].id,
            });
            if (response.data.action.success === true) {
                this.setState({
                    loading: false,
                });
            } else {
                this.setState({
                    loading: false,
                    errors: 'ha ocurrido un error al subir el diseño.',
                });
            }
        }
    }

    render() {
        const {order, userData} = this.props;
        const {status} = order;

        return (
            <Grid container spacing={2} direction='row' className={styles.routeSings}>
                <Grid item xs={12} md={6}>
                    <Box className={styles.box}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <p className={styles.title}>Datos del cartel de ruta</p>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='h3'>Proveedor elegido</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{
                                    order.extraData.supplier === 'otro'
                                        ? order.extraData.deteailedSupplier
                                        : order.extraData.supplier
                                }
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='h3'>Logo adjunto</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Link to={order.signFiles[0].logoFile} target='_blank'>
                                    <DescriptionOutlined /> {order.signFiles[0].logoName}
                                </Link>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='h3'>Presupuesto adjunto</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Link to={order.signFiles[0].budgetFile} target='_blank'>
                                    <DescriptionOutlined /> {order.signFiles[0].budgetName}
                                </Link>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='h3'>Dirección en el cartel</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{order.extraData.singAddress}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='h3'>Ubicación del cartel</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography>{order.extraData.signRoute}</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                {(status.id !== 'rejected'
                        && status.id !== 'pending_approval')
                        && (
                            <Grid item xs={12} md={6}>
                                <Box className={styles.box}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <p className={styles.title}>Diseño</p>
                                        </Grid>
                                        <Form
                                            fields={[
                                                {key: 'design', initial: ''},
                                            ]}
                                            errors={this.state.errors}
                                            loading={this.state.loading}
                                            onSubmit={this.submitDesign}>
                                            {({getFieldProps, renderErrors, isValid, values}) => {
                                                return (
                                                    <Grid container spacing={2} justify='flex-end'>
                                                        {order.signFiles[0].designName ? (
                                                            <Grid item xs={12}>
                                                                <Box className={styles.designBox}>
                                                                    <Grid container spacing={2} justify='space-between'>
                                                                        <Grid item>
                                                                            <Link to={order.signFiles[0].designFile} target='_blank'>
                                                                                <DescriptionOutlined /> {order.signFiles[0].designName}
                                                                            </Link>
                                                                        </Grid>
                                                                        {isSessionSupervisor(userData.user) && (
                                                                            <Grid item>
                                                                                <DeleteOutline className={styles.delete} onClick={this.handleDelete} fontSize='large' />
                                                                            </Grid>
                                                                        )}
                                                                    </Grid>
                                                                </Box>
                                                            </Grid>
                                                        ) : (
                                                            isSessionSupervisor(userData.user) && (
                                                                <Fragment>
                                                                    <Grid item xs={12}>
                                                                        <Field label='Por favor, adjuntá el archivo del diseño.'>
                                                                            <FileInput {...getFieldProps('design')} />
                                                                            {renderErrors('design')}
                                                                        </Field>
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <Form.Actions>
                                                                            <Button fullWidth theme='yellow' disabled={this.state.loading || !values.design}>
                                                                                {this.state.loading ? 'ENVIANDO...' : 'Enviar diseño'}
                                                                            </Button>
                                                                        </Form.Actions>
                                                                    </Grid>
                                                                </Fragment>
                                                            )
                                                        )}
                                                        {renderErrors('__all__')}
                                                    </Grid>
                                                );
                                            }}
                                        </Form>
                                    </Grid>
                                </Box>
                            </Grid>
                        )}
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-detail/route-sign-form/index.js